var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: [("key" + (_vm.name.toLowerCase())), _vm.classes, _vm.keyStateClass],
    attrs: {
      "title": _vm.title
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }